import { AppShell } from "@/components/app/AppShell";

export function PlaceholderScreen({ title, subtitle, emptyTitle, emptyText, icon: Icon, cta, testId }) {
  return (
    <AppShell>
      <div data-testid={testId} className="mx-auto max-w-content">
        <header className="mb-8">
          <h1 className="font-display text-4xl font-semibold text-brand-text sm:text-5xl">{title}</h1>
          {subtitle && <p className="mt-3 text-brand-sec">{subtitle}</p>}
        </header>
        <div className="flex flex-col items-start gap-4 rounded-panel border border-brand-line bg-brand-surface px-6 py-12">
          {Icon && (
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-brand-elevated text-brand-accent">
              <Icon size={22} strokeWidth={1.75} />
            </div>
          )}
          <div>
            <h2 className="font-display text-xl font-semibold text-brand-text">{emptyTitle}</h2>
            <p className="mt-2 max-w-lg text-brand-sec">{emptyText}</p>
          </div>
          {cta}
        </div>
      </div>
    </AppShell>
  );
}
